// Statewide GHG Service - Stub implementation
// This service handles fetching GHG data for cities and counties

export interface CityGHGData {
  name: string;
  location_name: string; // Add location_name property
  years: number[];
  emissions: number[];
  perCapitaEmissions?: number[];
}

export interface StatewideGHGData {
  year: number;
  total_emissions: number;
  perCapitaEmissions?: number;
}

export async function fetchAllCitiesGHGData(): Promise<CityGHGData[]> {
  // Stub implementation - returns empty array
  console.warn('statewideGHGService: fetchAllCitiesGHGData is not fully implemented');
  return [];
}

export async function fetchAllCountiesGHGData(): Promise<CityGHGData[]> {
  // Stub implementation - returns empty array
  console.warn('statewideGHGService: fetchAllCountiesGHGData is not fully implemented');
  return [];
}

export async function fetchStatewideGHGData(): Promise<StatewideGHGData[]> {
  // Stub implementation
  console.warn('statewideGHGService: fetchStatewideGHGData is not fully implemented');
  return [];
}